/**
 * Popular searches panel (snippets/predictive-search.liquid): shown while a search box
 * is focused and empty, hidden as soon as the customer types (predictive results take over).
 */
(() => {
  if (window.hbSearchPop) return;
  window.hbSearchPop = true;

  const panelFor = (input) => {
    const form = input.closest('form');
    return form && form.querySelector('.js-search-pop');
  };

  const update = (input) => {
    const panel = panelFor(input);
    if (!panel) return;
    panel.hidden = !(document.activeElement === input && input.value.trim() === '');
  };

  document.addEventListener('focusin', (evt) => {
    if (evt.target.matches('.js-search-input')) update(evt.target);
  });

  document.addEventListener('input', (evt) => {
    if (evt.target.matches('.js-search-input')) update(evt.target);
  });

  // Keep the panel open while focus moves onto one of its links; close it when focus leaves the form
  document.addEventListener('focusout', (evt) => {
    if (!evt.target.matches('.js-search-input')) return;
    const input = evt.target;
    setTimeout(() => {
      const panel = panelFor(input);
      if (panel && !panel.contains(document.activeElement)) update(input);
    }, 150);
  });

  document.addEventListener('focusout', (evt) => {
    const panel = evt.target.closest && evt.target.closest('.js-search-pop');
    if (!panel) return;
    setTimeout(() => {
      if (!panel.contains(document.activeElement)) {
        const input = panel.closest('form').querySelector('.js-search-input');
        if (document.activeElement !== input) panel.hidden = true;
      }
    }, 150);
  });

  document.addEventListener('keydown', (evt) => {
    if (evt.key !== 'Escape') return;
    document.querySelectorAll('.js-search-pop').forEach((panel) => {
      panel.hidden = true;
    });
  });

  // A tap on a chip shouldn't blur the input first and hide the panel before the click lands
  document.addEventListener('pointerdown', (evt) => {
    if (evt.target.closest('.hb-search-pop__chip')) evt.preventDefault();
  });
})();
